var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center"},[_c('span',[_vm._v("对不起，您暂无权限访问，请联系管理员")])])
}]

export { render, staticRenderFns }